import angular from 'angular';

export default angular
  .module('csm.util.ConstantTable', [])
  .factory('ConstantTable', constantTableFactory)
  .name;

constantTableFactory.$inject = [];

/*****************************************************************************
 * Constructor Factory: ConstantTable
 *
 * The instance is a wrapper for a table object and provides read access
 * for existing values as to ensure the integrity of any set values.
 *****************************************************************************/
function constantTableFactory() {
  return function () {
    /** Table value object. */ var table = {};

    /***************************************************************************
     * add */
    /**
     * Value setter, will only set for new keys.
     *
     * @param  {string}  name   Constant name to add to table
     * @param  {string}  value  Corresponding value.
     ***************************************************************************/
    this.add = function (name, value) {
      if (!table.hasOwnProperty(name)) table[name] = value;
    };

    /***************************************************************************
     * get */
    /**
     * Value accessor.
     *
     * @param  {string}  name   Name of constant to look up in the table
     * @return {string}         Value, if found.
     ***************************************************************************/
    this.get = function (name) {
      return table[name];
    };
  };
}
